export default {
  data() {
    return {
      fullLoader: null,
      quickFilterText: "",
      sortField: "",
      sortAsc: true,
    };
  },
  methods: {
    toggleSort(field) {
      if (this.sortField === field) {
        this.sortAsc = !this.sortAsc;
      } else {
        this.sortField = field;
        this.sortAsc = true;
      }
    },
    resolveField(obj, path) {
      if (!obj || !path) return "";
      var parts = path.split(".");
      var val = obj;
      for (var i = 0; i < parts.length; i++) {
        if (val == null) return "";
        val = val[parts[i]];
      }
      return val;
    },
    getCellValue(row, col) {
      var raw = col.valueGetter ? col.valueGetter(row) : this.resolveField(row, col.field);
      if (col.formatter) return col.formatter(raw, row);
      if (raw == null) return "";
      return raw;
    },
    filterAndSort(data, columns) {
      var result = data;
      if (this.quickFilterText) {
        var q = this.quickFilterText.toLowerCase();
        var self = this;
        result = result.filter(function (row) {
          for (var i = 0; i < columns.length; i++) {
            var val = self.getCellValue(row, columns[i]);
            if (val != null && String(val).toLowerCase().indexOf(q) !== -1) return true;
          }
          return false;
        });
      }
      if (this.sortField) {
        var field = this.sortField;
        var asc = this.sortAsc;
        var self2 = this;
        var col = columns.find(function (c) { return c.field === field; });
        result = result.slice().sort(function (a, b) {
          var va = col ? self2.getCellValue(a, col) : self2.resolveField(a, field);
          var vb = col ? self2.getCellValue(b, col) : self2.resolveField(b, field);
          if (va == null) va = "";
          if (vb == null) vb = "";
          if (typeof va === "number" && typeof vb === "number") {
            return asc ? va - vb : vb - va;
          }
          va = String(va).toLowerCase();
          vb = String(vb).toLowerCase();
          if (va < vb) return asc ? -1 : 1;
          if (va > vb) return asc ? 1 : -1;
          return 0;
        });
      }
      return result;
    },
    getApiError(d) {
      if (d && d.status === "error") return d.message || d.data && d.data.error || "";
      if (d && d.data && d.data.error) return d.data.error;
      return null;
    },
    showLoader() {
      this.fullLoader = this.$loading.show({
        container: null,
        canCancel: false,
        height: 40,
        width: 40,
        loader: "spinner",
        color: "#333333",
        backgroundColor: "#EEF2FE",
        opacity: 0.6,
      });
    },
    hideLoader() {
      if (this.fullLoader) {
        this.fullLoader.hide();
      }
    },
  },
};
